<template>
  <q-field label="Date" outlined dense v-model="dateRange" class="adjust">
    <template v-slot:prepend>
      <q-icon name="event" />
    </template>
    <template v-slot:append>
      <q-btn
        round
        dense
        icon="cancel"
        @click="onClearDateRange()"
        v-if="
          dateRange.startDate != '' && dateRange.endDate != ''
        "
      />
    </template>
    <template v-slot:control>
      <date-range-picker v-model="dateRange" :opens="position">
        <template v-slot:input="picker" style="min-width: 350px">
          <span
            v-if="
              picker.startDate &&
              picker.endDate &&
              dateRange.startDate != '' &&
              dateRange.endDate != ''
            "
          >
            {{ moment(picker.startDate).format("MMM Do YYYY") }} -
            {{ moment(picker.endDate).format("MMM Do YYYY") }}
          </span>
          <span v-else> - </span>
        </template>
        <div slot="footer" slot-scope="data" class="slot">
          <div data-v-1ebd09d2="" class="drp-buttons">
            <span data-v-1ebd09d2="" class="drp-selected"> - </span>
            <button
              data-v-1ebd09d2=""
              v-on:click="data.clickCancel"
              type="button"
              class="cancelBtn btn btn-sm btn-secondary"
            >
            </button>
            <button
              data-v-1ebd09d2=""
              type="button"
              @click="data.clickApply"
              class="applyBtn btn btn-sm btn-success"
            >
              Apply
            </button>
          </div>
        </div>
      </date-range-picker>
    </template>
  </q-field>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment-timezone";

export default {
  props: {
    value: String,
    position:{
      type:String,
      default:'center'
    },
  },
  data() {
    return {
      moment: moment,
      dateRange: {
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    onClearDateRange() {
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
    },
  },
  mounted() {
  },
   components: {
    DateRangePicker,
  },
  watch: {
    dateRange: {
      handler() {
        this.$emit("input", this.dateRange);
      },
      deep: true,
    },
  },
};
</script>
<style>
.reportrange-text[data-v-1ebd09d2] {
  background: black !important;
  height: auto !important;
  border: none !important;
}
.daterangepicker.openscenter:after,
.daterangepicker.openscenter:before {
  left: 288px;
  right: 0;
  width: 0;
  margin-left: auto;
  margin-right: auto;
}
.daterangepicker.openscenter[data-v-1ebd09d2] {
  right: auto;
  left: -11%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.calendars[data-v-1ebd09d2] {
  background-color: black;
}
.daterangepicker.show-calendar .drp-buttons,
.daterangepicker.show-calendar .drp-calendar {
  display: block;
  background-color: black;
}
.daterangepicker {
  background-color: #616161;
}
td[data-v-98ac2448],
th[data-v-98ac2448] {
  padding: 2px;
  background-color: #000;
}
.daterangepicker .calendar-table {
  border: 1px solid #000;
  border-radius: 4px;
  background-color: black;
}
.daterangepicker td.off,
.daterangepicker td.off.end-date,
.daterangepicker td.off.in-range,
.daterangepicker td.off.start-date {
  background-color: black;
  border-color: #000;
  color: black;
}
.daterangepicker td.in-range {
  background-color: #14add2;
  border-color: transparent;
  color: #ffff;
  border-radius: 0;
}
.daterangepicker .btn-primary,
.daterangepicker .btn-success {
  background-color: #7b7b7b;
  color: #fff;
}
.daterangepicker .calendar-table .next span,
.daterangepicker .calendar-table .prev span {
  color: #fff;
  border: solid #ffff;
  border-width: 0 2px 2px 0;
  border-radius: 0;
  display: inline-block;
  padding: 3px;
}
.daterangepicker .ranges li.active {
  background-color: #14add2;
  color: #fff;
}
.vue-daterange-picker {
  width: 100%;
  font-size: 12px;
}

.daterangepicker .btn-secondary {
    background-color: #000;
    color: #fff;
}
.daterangepicker .drp-selected {
    display: inline-block;
    font-size: 12px;
    padding-right: 8px;
    color: #0000;
}

</style>
